import { FC, useCallback } from 'react';
import {
  List,
  ListItemText,
  MenuItem,
  Tooltip,
  Typography,
} from '@mui/material';
import { handleDownloadOrgSbom } from '../../applications/actions/applications-sbom-actions';
import { DownloadType } from '../../applications/applications-types';
import {
  MdDownload as DownloadIcon,
  MdExpandMore as ExpandMoreIcon,
} from 'react-icons/md';
import ControlActionButton from '../../applications/components/control-components/ControlActionButton';
import { useIsScanning } from '../../new-scan/actions/scan-actions';
import ExtendedMenuItem from '../../elements/OxMenu/ExtendedMenuItem';
import SubMenuItem from '../../elements/OxMenu/SubMenuItem';

const SbomMenuDownload: FC<SbomMenuDownloadProps> = ({
  csvDownloadDisabledSearch,
  csvDownloadDisabledFilter,
  isLoadingFilters,
  isLoadingSbom,
}) => {
  const isScanning = useIsScanning();

  const handleDownloadTypeOrgSbom = useCallback(
    (type: DownloadType, filtered?: boolean) => {
      handleDownloadOrgSbom(type, filtered);
    },
    [],
  );

  return (
    <Tooltip
      arrow
      placement='bottom'
      title={
        <>
          <MenuItem
            disabled={
              csvDownloadDisabledFilter ||
              csvDownloadDisabledSearch ||
              isLoadingFilters ||
              isLoadingSbom ||
              isScanning
            }
            onClick={() => handleDownloadTypeOrgSbom(DownloadType.CSV, true)}
            sx={{
              '> *': { minWidth: '36px !important' },
            }}>
            <Typography variant='body2' color='text.primary'>
              Filtered CSV
            </Typography>
          </MenuItem>
          <ExtendedMenuItem
            id='sbom-org-menu'
            withIcon
            disabled={isLoadingSbom || isLoadingFilters || isScanning}
            subMenu={
              <List>
                <SubMenuItem
                  disabled={isLoadingSbom || isLoadingFilters || isScanning}
                  onClick={() => handleDownloadTypeOrgSbom(DownloadType.CSV)}>
                  <Typography variant='body2' color='text.primary'>
                    CSV
                  </Typography>
                </SubMenuItem>
                <SubMenuItem
                  disabled={isLoadingSbom || isLoadingFilters || isScanning}
                  onClick={() => handleDownloadTypeOrgSbom(DownloadType.JSON)}>
                  <Typography variant='body2' color='text.primary'>
                    CycloneDX JSON
                  </Typography>
                </SubMenuItem>
              </List>
            }>
            <ListItemText
              sx={{
                '> *': { minWidth: '36px !important' },
              }}>
              <Typography variant='body2' color='text.primary'>
                For Entire Org
              </Typography>
            </ListItemText>
          </ExtendedMenuItem>
        </>
      }>
      <div>
        <ControlActionButton
          label='Download SBOM'
          startIcon={<DownloadIcon />}
          endIcon={<ExpandMoreIcon />}
          disabled={isScanning}
        />
      </div>
    </Tooltip>
  );
};

export interface SbomMenuDownloadProps {
  csvDownloadDisabledSearch: boolean;
  csvDownloadDisabledFilter: boolean;
  isLoadingFilters: boolean;
  isLoadingSbom: boolean;
}

export default SbomMenuDownload;
